import API from "../../api/apiAdmin";

/**
 * Service for administrative management of newsletter subscribers.
 */
export const AdminSubscribersService = {
    /**
     * Admin: List all subscribers
     * @param {number} page 
     * @param {number} perPage 
     * @param {string} search 
     */
    getSubscribers: async (page = 1, perPage = 20, search = "") => {
        try {
            const response = await API.get("/admin/subscribers", {
                params: { page, per_page: perPage, search }
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching subscribers:", error);
            throw error;
        }
    },

    /**
     * Admin: Update subscriber status (active/blocked)
     * @param {string} id 
     * @param {string} status 
     */
    updateStatus: async (id, status) => {
        try {
            const response = await API.patch(`/admin/subscribers/${id}/status`, { status });
            return response.data;
        } catch (error) {
            console.error("Error updating subscriber status:", error);
            throw error;
        }
    },

    /**
     * Admin: Delete a subscriber
     * @param {string} id 
     */
    deleteSubscriber: async (id) => {
        try {
            const response = await API.delete(`/admin/subscribers/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting subscriber:", error);
            throw error;
        }
    }
};
